import React, { useEffect, useState } from 'react';
import './Introduction.scss';
/*import LocationIcon from '../icons/LocationIcon';*/
import { ReactComponent as ArrowIcon } from '../assets/arrow_forward_large.svg';

export interface IntroductionProps {
  sessionName: string;
  startAction: () => void;
  setShowHowThisWorks: () => void;
  setShowAbout: () => void;
  viewHistoricAction: () => void;
  chooseResume: boolean;
  allowReview: boolean;
  location: string | null | undefined;
  startDateUtc: string | null | undefined;
  isPresenting: boolean | null | undefined;
  welcomeImageUrl: string | null | undefined;
  iconUrl: string | null | undefined;
  showAboutAvailable: boolean;
  isDefault: boolean;
}

const Introduction: React.FC<IntroductionProps> = ({
  sessionName,
  welcomeImageUrl,
  iconUrl,
  startDateUtc,
  isPresenting,
  startAction,
  setShowHowThisWorks,
  setShowAbout,
  viewHistoricAction,
  chooseResume,
  allowReview,
  location,
  showAboutAvailable,
  isDefault
}) => {
  function formatDate(dateString: string): string {
    const date = new Date(dateString);

    const days = [
      'Sunday',
      'Monday',
      'Tuesday',
      'Wednesday',
      'Thursday',
      'Friday',
      'Saturday'
    ];
    const months = [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December'
    ];

    const dayOfWeek = days[date.getDay()];
    const dayOfMonth = date.getDate();
    const month = months[date.getMonth()];

    const suffix = (n: number) => {
      if (n >= 11 && n <= 13) return 'th';
      switch (n % 10) {
        case 1:
          return 'st';
        case 2:
          return 'nd';
        case 3:
          return 'rd';
        default:
          return 'th';
      }
    };

    return `${dayOfWeek} ${dayOfMonth}${suffix(dayOfMonth)} ${month}`;
  }
  function formatTime(dateString: string): string {
    // Parse the string into a Date object
    const date = new Date(
      dateString.endsWith('Z') ? dateString : dateString + 'Z'
    );

    // Format time part
    let hours = date.getHours();
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const ampm = hours >= 12 ? 'pm' : 'am';

    // Convert to 12-hour format
    hours = hours % 12 || 12; // converts "0" hour to "12" for midnight

    const formattedTime = `${hours}:${minutes}${ampm}`;
    return formattedTime;
  }
  /*
  const [isPassed, setIsPassed] = useState(
    startDateUtc && new Date(startDateUtc) < new Date()
  );

  useEffect(() => {
    if (!startDateUtc || isPassed) {
      return;
    }
    const checkDate = () => {
      const currentDate = new Date();
      //TODO: Reinstate this line
      if (currentDate >= new Date(startDateUtc)) {
        //if (currentDate <= new Date(startDateUtc)) {
        setIsPassed(true);
      }
    };

    checkDate();

    const intervalId = setInterval(() => {
      checkDate();
    }, 1000); // Adjust time as needed (ms)

    return () => clearInterval(intervalId);
  }, []);
*/

  return (
    <div className="welcome-container">
      {welcomeImageUrl && (
        <img
          src={welcomeImageUrl}
          className="welcome-image"
          alt="Welcome image for the event"
        />
      )}
      {iconUrl && (
        <img src={iconUrl} className="welcome-icon" alt="Icon for the event" />
      )}
      <h1 className="welcome-message">{sessionName}</h1>
      {location && <h2>{location}</h2>}
      {startDateUtc && !isPresenting && (
        <>
          <span className="intro">The event will begin shortly.</span>
          {!isDefault && (
            <div className="upcoming-time">
              <span className="date">{formatDate(startDateUtc)}</span>
              <span className="time">
                {formatTime(startDateUtc)}
                {/*<LocationIcon
                tooltipText={Intl.DateTimeFormat().resolvedOptions().timeZone}
              />*/}
              </span>
            </div>
          )}
        </>
      )}
      {!(startDateUtc && !isPresenting) && (
        <div className="is-live">
          <span className="intro">Now Live</span>
          {chooseResume && (
            <p>
              You have joined a previous showing of this event. Would you like
              to join the current showing, or view the previous event?
            </p>
          )}
          <div className="buttons">
            {!allowReview && !chooseResume && (
              <button className="primary" onClick={() => startAction()}>
                Join the show
              </button>
            )}
            {allowReview && !chooseResume && (
              <>
                <p>This event has finished, but you can review what happened</p>
                <button className="primary" onClick={() => startAction()}>
                  Review
                </button>
              </>
            )}
            {chooseResume && (
              <>
                <button className="primary" onClick={() => startAction()}>
                  Join current showing
                </button>
                <button onClick={() => viewHistoricAction()}>
                  View historic showing
                </button>
              </>
            )}
          </div>
        </div>
      )}

      {!isPresenting && (
        <div className="buttons-single">
          <button className="primary" onClick={() => startAction()}>
            Join and wait
          </button>
        </div>
      )}

      <div className="buttons">
        <button onClick={setShowHowThisWorks}>
          <ArrowIcon /> How this works
        </button>
        {showAboutAvailable && (
          <button onClick={setShowAbout}>
            <ArrowIcon /> About the event
          </button>
        )}
      </div>
    </div>
  );
};

export default Introduction;
